/**
 * @name plant-pot
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgOC41MzZWNmE0IDQgMCAwMTQtNGgxLjVhLjUuNSAwIDAxLjUuNVY0YTQgNCAwIDAxLTQgNCA0IDQgMCAwMC00IDQgNSA1IDAgMDEtOC00IDUgNSAwIDAxOCA0YzAgMiAxIDMgMSA1IiAvPgogIDxwYXRoIGQ9Im0xOCAxNy0xLjA4NSAzLjU4QTIgMiAwIDAxMTUgMjJIOS4wMDJhMiAyIDAgMDEtMS45MTMtMS40MThMNiAxNyIgLz4KICA8cGF0aCBkPSJNNSAxN2gxNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/plant-pot
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const PlantPot: string = `
<svg
  class="lucide lucide-plant-pot"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M14 8.536V6a4 4 0 014-4h1.5a.5.5 0 01.5.5V4a4 4 0 01-4 4 4 4 0 00-4 4 5 5 0 01-8-4 5 5 0 018 4c0 2 1 3 1 5" />
  <path d="m18 17-1.085 3.58A2 2 0 0115 22H9.002a2 2 0 01-1.913-1.418L6 17" />
  <path d="M5 17h14" />
</svg>
`;

export default PlantPot;
